import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const RangesEmptyState: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="ranges-empty d-flex flex-column align-items-center justify-content-center text-center">
      <div className="ranges-empty__icon">
        <em className="icon ni ni-list-index" />
      </div>
      <p className="ranges-empty__title">{t('NoRangesFound')}</p>
      <p className="ranges-empty__text">{t('NoRangesFoundDescription')}</p>
    </div>
  );
};

export default RangesEmptyState;
